export enum AnalyticsEvent {
  AllOffersDeclined = "all_offers_declined",
  ApiErrorDisplayed = "api_error_displayed",
  ApplicationChanged = "application_changed",
  ApplicationStageViewed = "application_stage_viewed",
  ChatMessageSent = "chat_message_sent",
  ChatSessionEnded = "chat_session_ended",
  ChatSessionStarted = "chat_session_started",
  CheckoutCompleted = "checkout_completed",
  CheckoutCustomStepUrlVisited = "checkout_custom_step_url_visited",
  CheckoutStarted = "checkout_started",
  CheckoutStepCompleted = "checkout_step_completed",
  DeclineReasonDropdownOpened = "decline_reason_dropdown_opened",
  DocumentDeleted = "document_deleted",
  DocumentUploadFailed = "document_upload_failed",
  DocumentUploaded = "document_uploaded",
  DynamicOfferFieldAdjusted = "dynamic_offer_field_adjusted",
  DynamicOfferGroupExpanded = "dynamic_offer_group_expanded",
  EmailConfirmed = "email_confirmed_with_magic_link",
  FeedbackSubmitted = "feedback_submitted",
  FundingAdvisorContacted = "funding_advisor_contacted",
  LoginAttempted = "login_attempted",
  LoginFailed = "login_failed",
  LogoutClicked = "logout_clicked",
  MagicLinkResent = "magic_link_resent",
  OfferAccepted = "offer_accepted",
  OfferCarouselNavigated = "offer_carousel_navigated",
  OfferDetailsCollapsed = "offer_details_collapsed",
  OfferDetailsExpanded = "offer_details_expanded",
  OfferRejected = "offer_rejected",
  TabClicked = "tab_clicked",
  UnandledErrorThrown = "unhandled_error_thrown",
}
